import Sidebar from '../../components/sidebar/sidebar';
import Header from '../../components/header';
import Card from '../../components/Card';
import PatchDeploymentForm from './PatchDeploTable';
import { ToastProvider } from '../../providers/ToastProvider/ToastContext';

const PatchDeployment = () => {
  return (
    <ToastProvider>
      <div className="flex">
        <Sidebar></Sidebar>
        <div className="bg-[var(--Background-Color,#161617)] flex-1">
          <Header title="Software Deployment" dropdown={2} showBackButton={true} />

          <Card className="flex-1">
            <PatchDeploymentForm />
          </Card>
        </div>
      </div>
    </ToastProvider>
  );
};

export default PatchDeployment;
